<template>
  <van-overlay class="custom-loading" :style="cssStyle" :show="visible">
    <div class="wrapper" :style="cssStyle" @click.stop>
      <van-loading color="#173CCC" size="30px" vertical>{{text}}</van-loading>
    </div>
  </van-overlay>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "加载中..." // 加载中...
    },
    cssStyle: {
      type: String,
      default: ""
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 54px;
  height: 58px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}

.custom-loading {
  background: rgba(255, 255, 255, .95);
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2001;
}
</style>
